import * as t from 'ts-schema';
import * as OfferingTypes from './constants/OfferingType';
export const offeringTypeSchema = t.union(...Object.values(OfferingTypes).map(val => t.literal(val)));